<template>
  <div class="conversation-container">
    <ConversationHeader
      :brandColour="brandColour"
      :outboundMessageColour="outboundMessageColour"
      :headerText="headerText"
      :subtitleText="typicalResponseTime"
    />
    <div class="conversation-container__body">
      <n-conversation
        :readonlyApps="readonlyApps"
        :messages="messages"
        :outboundMessageColour="outboundMessageColour"
        :displayAvatar="displayAvatar"
        :enableAvatarTooltip="enableAvatarTooltip"
        @sendQuickReply="(quickReply: string) => $emit('sendQuickReply', quickReply)"
        @messageSend="(message: string) => $emit('messageSend', message)"
        @conversationRead="$emit('conversationRead')"
        @typingStart="$emit('typingStart')"
        @typingStop="$emit('typingStop')"
      ></n-conversation>
    </div>
  </div>
</template>

<script lang="ts" setup>
import ConversationHeader from './ConversationHeader.vue';
import { ConversationMessage } from '../../models/conversation-message';
import { default as ColourPicker } from '@/shared/services/color';
import { PropType } from 'vue';

const props = defineProps({
  brandColour: {
    type: String,
    required: true,
  },
  outboundMessageColour: {
    type: String,
    default: '#062b80',
  },
  actionColour: {
    type: String,
    required: true,
  },
  headerText: {
    type: String,
    required: true,
  },
  typicalResponseTime: {
    type: String,
    required: true,
  },
  displayAvatar: {
    type: Boolean,
    default: false,
  },
  enableAvatarTooltip: {
    type: Boolean,
    default: false,
  },
  messages: {
    type: Array as PropType<ConversationMessage[]>,
    required: true,
  },
  readonlyApps: {
    type: Boolean,
    default: true,
  },
});
</script>

<style scoped lang="scss">
.conversation-container {
  flex: 1;
  display: flex;
  flex-flow: column;
  border-radius: 8px;
  height: 100%;

  &__body {
    flex: 1;
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
    font-size: 1em;
    height: 100%;
    overflow: hidden;
    border-radius: 8px;
  }

  :deep(.n-message-composer) {
    border-radius: 0 0 8px 8px;
  }

  :deep(.n-text-message--left),
  :deep(.n-app-message--left) {
    padding-left: 1.5em;
  }
}
</style>
